// extracted by css-extract-rspack-plugin
export default {"root":"vcnBKVO1pLQs7Qqo","sticky":"U1NRkou075uQB9Dy"};